import { useQuery } from '@tanstack/react-query'

import { QUERY_KEYS } from 'constants/constants'
import { query } from '../graphql'

export const useActiveSpaceQuery = ({
  active_space_id,
  refetchOnWindowFocus = false
}) => {
  return useQuery({
    queryKey: QUERY_KEYS.activeSpaceById(active_space_id),
    queryFn: () => {
      return query({ query: 'getSpace', variables: { id: active_space_id } })
    },
    enabled: !!active_space_id,
    refetchOnWindowFocus
  })
}
